import {Component, inject} from "@angular/core";
import {RouterLink} from "@angular/router";
import {WEB_APP_CONFIG} from "../../../common/app-config";
import {HeaderComponent} from "../../layout/header/header.component";
import {LargeLogoShearComponent} from "../../layout/large-logo-shear/large-logo-shear.component";

@Component({
  selector: "app-privacy",
  templateUrl: "./privacy.component.html",
  imports: [
    HeaderComponent,
    RouterLink,
    LargeLogoShearComponent,
  ],
})
export class PrivacyComponent {
  protected readonly isUsingAppleMaps = !!inject(WEB_APP_CONFIG).appleMapsEmbeddingSettings;
}
